import { ArrowRight, Filter, Grid, List, Plus, Search } from "react-feather";
import styles from "./filter.module.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import FilterAutocomplete from "../../../components/FilterAutocomplete";

const TYPE_OPTIONS = [{ value: 0, label: "Tenant" }, { value: 1, label: "Guest" }];
const STATUS_OPTIONS = [
    { value: "active", label: "Active" },
    { value: "pending", label: "Pending approval" },
    { value: "rejected", label: "Rejected" },
    { value: "disabled", label: "Disabled" },
];

const VehicleFilter = ({ handleView, isGridView, filterData, setFilterData, setAddModalOpen }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);

    useEffect(() => {
        async function getProperties() {
            try {
                const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

                const response = await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setPropertyList(response.data?.data || []);
            } catch (error) {
                console.error("[Vehicles] Failed to load property list", error);
                toast.error(error?.response?.data?.message || "Unable to load properties. Please try again.");
            }
        }
        getProperties();
    }, [getAccessTokenSilently]);

    // Derived from the selected property so the list and grid view filters (two instances) stay in sync
    const apartmentList = propertyList.find((i) => i.value === filterData?.property)?.apartments || [];

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); }} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Property"
                        options={propertyList}
                        value={filterData?.property}
                        onChange={(value) => { setFilterData((prev) => ({ ...prev, property: value, apartment: "" })); }}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Apartment"
                        options={apartmentList}
                        value={filterData?.apartment}
                        noOptionsText={!filterData?.property ? "Select Property First" : "No options"}
                        placeholder={apartmentList.length === 0 ? "Select Property First" : "Search apartment"}
                        onChange={(value) => { setFilterData((prev) => ({ ...prev, apartment: value })); }}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Type"
                        options={TYPE_OPTIONS}
                        value={filterData?.type}
                        onChange={(value) => { setFilterData((prev) => ({ ...prev, type: value })); }}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Status"
                        options={STATUS_OPTIONS}
                        value={filterData?.status}
                        onChange={(value) => { setFilterData((prev) => ({ ...prev, status: value })); }}
                    />
                </div>
            </div>
            <div className={`${styles.ListGridBUCard}`}>
                {isGridView ? <div className={`${styles.ListGridBUSec}`}>
                    <div className={`${styles.ListGridBU} `} onClick={() => handleView("list")}>
                        <List /> <span>List</span>
                    </div>
                    <div className={`${styles.ListGridBU} ${styles.Active}`}>
                        <Grid /> <span>Grid</span>
                    </div>
                </div> : <div className={`${styles.ListGridBUSec}`}>
                    <div className={`${styles.ListGridBU}  ${styles.Active}`}>
                        <List /> <span>List</span>
                    </div>
                    <div className={`${styles.ListGridBU}`} onClick={() => handleView("grid")}>
                        <Grid /> <span>Grid</span>
                    </div>
                </div>}
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Vehicle</span>
            </Link>}
        </div>
    </div >)
}

export default VehicleFilter;
